export default __webpack_public_path__ + "static/media/58.d475ca31.jpg";